/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Create_Incomplete_Confirm_TitleInputs */

const en_case_create_incomplete_confirm_title = /** @type {(inputs: Case_Create_Incomplete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create case with missing information?`)
};

const pt_br2_case_create_incomplete_confirm_title = /** @type {(inputs: Case_Create_Incomplete_Confirm_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar caso com informações pendentes?`)
};

/**
* | output |
* | --- |
* | "Create case with missing information?" |
*
* @param {Case_Create_Incomplete_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_create_incomplete_confirm_title = /** @type {((inputs?: Case_Create_Incomplete_Confirm_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Create_Incomplete_Confirm_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_create_incomplete_confirm_title(inputs)
	return pt_br2_case_create_incomplete_confirm_title(inputs)
});